<template>
  <DefaultButton
    :loading="loading"
    class="h-full"
    @click="
      addToCart.addCollectionProductToCart(
        collectionStore.selectedEndProductValue!
      )
    "
  >
    <template #icon>
      <CartIcon class="h-11 py-2 md:h-8 md:py-1" />
    </template>

    <template #default>
      {{ $t('pages.extra_options.add_to_cart') }}
    </template>
  </DefaultButton>

  <FullPageLoader v-if="showLoader" :current-step="currentStep" />
</template>

<script setup lang="ts">
import CartIcon from '@/components/Icons/CartIcon.vue';
import FullPageLoader from '@/components/States/FullPageLoader.vue';
import { useAddToCart } from '@/composables/UseAddToCart';
import i18n from '@/i18n';
import { useCollectionStore } from '@/stores/Collection/CollectionStore';
import { computed } from 'vue';
import DefaultButton from '@/components/Buttons/DefaultButton.vue';

const collectionStore = useCollectionStore();
const addToCart = useAddToCart();

const loading = computed(
  () =>
    addToCart.isAwaitingRedirect.value ||
    addToCart.addCollectionProductToCartRequest.isLoading
);

const showLoader = computed(
  () => addToCart.isAwaitingRedirect.value || addToCart.isRequesting.value
);

const currentStep = computed(() => {
  if (addToCart.isAwaitingRedirect.value) {
    return i18n.global.t('loader.currentstep.redirecting_to_cart');
  }

  return i18n.global.t('loader.currentstep.adding_to_cart');
});
</script>
